import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/football.webp";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));

const TITLE = "Décompte jusqu'à la Coupe du Monde 2026 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'à la Coupe du Monde FIFA 2026 ? Le décompte jusqu'à la Coupe du Monde vous fournit des informations précises sur la date de début du tournoi, combien de jours restent jusqu'au lancement du plus grand événement footballistique au monde.";
const KEYWORDS = "Coupe du Monde 2026, FIFA 2026, décompte Coupe du Monde, date Coupe du Monde 2026, combien de jours jusqu'à la Coupe du Monde 2026, Mondial 2026";
const OG_URL = "https://do-calculate.com/articles-fr/worldcup";

function WorldCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const worldCupDate = new Date("2026-06-08T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(worldCupDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(worldCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">Décompte jusqu'à la Coupe du Monde 2026</h1>
            <Suspense fallback={<div>Chargement...</div>}>
                <BlinkingText text="Décompte jusqu'à la Coupe du Monde : le tournoi devrait débuter le lundi 8 juin 2026 aux États-Unis, au Canada et au Mexique." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Informations sur la Coupe du Monde 2026</h3>
                    <p>
                        La Coupe du Monde de football est l'événement sportif le plus suivi au monde, où les équipes nationales s'affrontent pour remporter le titre le plus prestigieux du football mondial. La Coupe du Monde 2026 sera particulièrement unique car elle se déroulera pour la première fois dans trois pays différents : les États-Unis, le Canada et le Mexique. Les amateurs de football attendent cet événement avec impatience, car la compétition verra la participation de 48 équipes nationales pour la première fois de l'histoire, rendant la compétition plus intense et plus grande que jamais.
                    </p>
                    <p>
                        La prochaine édition de la Coupe du Monde est une étape importante dans l'histoire du tournoi, car ce sera la première édition avec l'expansion du nombre d'équipes participantes, offrant plus d'opportunités aux équipes nationales de participer et de réaliser de nouveaux exploits.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Chargement...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col-sm-4 col-md-4">
                    <Suspense fallback={<div>Chargement...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">La Coupe du Monde FIFA</h3>
                    <p>
                        La Coupe du Monde FIFA est organisée tous les quatre ans et rassemble les meilleures équipes nationales du monde entier. La France, championne du monde en titre depuis 2018, sera l'une des équipes les plus attendues lors de cette édition 2026.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'à la Coupe du Monde 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default WorldCupCountdown;
